'use strict';

// export this package's api
module.exports = require('./Upload');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.3.2@rc-upload/lib/index.js
 ** module id = 444
 ** module chunks = 0 1
 **/